/**
 * 事件总线插件
 * https://github.com/yangmingshan/vue-bus
 */

import Vue from 'vue';
import VueBus from 'vue-bus';

Vue.use(VueBus);
